import { useFetchMixAPi1 } from "hooks";

export const useEspecificacoesDetail = id =>
  useFetchMixAPi1(id ? `/legislacao/especificacoes/detalhe/${id}` : null);
